import React, { useState } from "react";
import {
  Container,
  Typography,
  TextField,
  Button,
  Grid,
  CircularProgress,
} from "@mui/material";
import { useLocation } from "react-router-dom";
import ResponsiveAppBar from "../../components/AppBar";
import "react-multi-email/dist/style.css";
import { ReactMultiEmail } from "react-multi-email";
import { sendInvitations } from "../../services/company";
import { toast } from "react-toastify";

const HomePage = () => {
  const [emails, setEmails] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const userProfile = location.state.profile;

  console.log(userProfile);

  const myStyle = {
    padding: "10px",
    paddingBottom: "20px",
    borderRadius: "5px",
    marginBottom: "20px",
    marginTop: "10px",
  };

  const handleInvitations = async () => {
    setIsLoading(true);

    const invitationInfo = {
      companyId: userProfile.company.id,
      invitedBy: userProfile._id,
      companyName: userProfile.company.name,
      email: emails,
    };

    try {
      await sendInvitations(invitationInfo);
      toast.success("Invitaciones enviadas correctamente");
      setEmails([]);
    } catch (error) {
      toast.error("Ocurrio un error al enviar las invitaciones");
    }

    setIsLoading(false);
  };

  return (
    <>
      <ResponsiveAppBar fullName={userProfile.profile.fullname} />
      <Container
        maxWidth="sm"
        style={{ marginTop: "64px", textAlign: "center", gap: "10px" }}
      >
        <Grid container spacing={2} justifyContent="center" alignItems="center">
          <Grid item xs={12}>
            <Typography variant="h6" gutterBottom>
              Bienvenido a GerenUC, {userProfile.profile.fullname}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h5" gutterBottom>
              Perteneces a la empresa {userProfile.company.name}
            </Typography>
          </Grid>
          {userProfile.owner && (
            <>
              <Grid
                container
                spacing={2}
                justifyContent="center"
                alignItems="center"
              >
                <Grid item xs={12}>
                  <TextField
                    label="API KEY"
                    variant="outlined"
                    margin="normal"
                    fullWidth
                    disabled
                  />
                </Grid>
                <Grid item xs={12}>
                  <Button variant="contained" color="primary" fullWidth>
                    Generar API KEY
                  </Button>
                </Grid>
              </Grid>
              <Grid
                container
                justifyContent="center"
                alignItems="center"
                marginTop={6}
              >
                <Grid item xs={12}>
                  <Typography
                    variant="h7"
                    gutterBottom
                    style={{ marginTop: "24px" }}
                  >
                    Invitar colaboradores
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <ReactMultiEmail
                    placeholder="Invite a colaboradores por mail"
                    style={myStyle}
                    emails={emails}
                    onChange={(emails) => setEmails(emails)}
                    autoFocus={true}
                    getLabel={(email, index, removeEmail) => {
                      return (
                        <div data-tag key={index}>
                          <div data-tag-item>{email}</div>
                          <span
                            data-tag-handle
                            onClick={() => removeEmail(index)}
                          >
                            ×
                          </span>
                        </div>
                      );
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  {isLoading ? (
                    <CircularProgress />
                  ) : (
                    <Button
                      variant="contained"
                      color="primary"
                      fullWidth
                      onClick={handleInvitations}
                      disabled={emails.length === 0}
                    >
                      Enviar Invitaciones
                    </Button>
                  )}
                </Grid>
              </Grid>
            </>
          )}
        </Grid>
      </Container>
    </>
  );
};

export default HomePage;
